import React from "react";
import {Navigate, Params, useParams} from "react-router-dom";
import useFetchResult from "../../../../../hooks/UseFetchResult";
import PageActions from "../../../../base/PageActions";
import _naming_service from "../../../../../services/NamingService";
import _http_service from "../../../../../services/HttpService";

interface ComicLatestRedirectPageProps {
}

interface ComicLatestRedirectPageResult {
    comic: string,
    chapter: number,
    page?: number,
}

interface ComicLatestRedirectPageParams extends Params {
    comic: string
}

const ComicLatestRedirectPage = (props: ComicLatestRedirectPageProps) => {

    const params = useParams<ComicLatestRedirectPageParams>();

    const _initial_state: ComicLatestRedirectPageResult = {
        comic: params.comic!,
        chapter: params.chapter ? +params.chapter : 0
    };

    const [getResult, hasFetchedResult, setFetchedResult] = useFetchResult<ComicLatestRedirectPageResult>(
        _initial_state, async () => {
            if (!_initial_state.comic) {
                throw new Error("Could not get current comic!");
            }
    
            return _http_service.getLatestComicPage(_initial_state.comic)
                .then(response => {
                    if (!response || response.length < 2) {
                        throw new Error("Could not get latest comic page!");
                    }

                    let latestChapter = response[0];
                    let latestPage = response[1];
                    return {
                        ..._initial_state,
                        chapter: latestChapter,
                        page: latestPage
                    };
            });
    }, []);

    const page: PageActions = new PageActions({
        title: `${_naming_service.capitalizeName(getResult().comic)}: Latest Page - Chase the Fox`,
        description: `The most recent page of Tale Chasers`,
        keywords: ["comic", "webcomic", getResult().comic],
        imgSrc: `chase/comic/talechasers/tale_chasers_logo.png`,
        url: `comics/${getResult().comic}/latest`
    });

    return page.generateMetaContent(
        <>
            {hasFetchedResult
                ? <Navigate replace to={`/comics/${params.comic}/${getResult()!.chapter}/${getResult()!.page}`}/>
                : <></>}
        </>
    );
}

export default ComicLatestRedirectPage;